import { Typography, Avatar } from "@mui/material"
import { useCallback, useMemo } from "react"

export default function DetailAvatar({ name }: { name: string }) {
  const getAvatarLetter = useCallback((name: string) => {
    const words = name?.split(" ")
    if (words) {
      if (words?.length === 1) {
        return words[0][0]?.toUpperCase() // If single name, return the first letter
      }
      return (
        words[0][0]?.toUpperCase() + words[words.length - 1][0]?.toUpperCase()
      ) // If multiple names, return first and last initials
    }
    // return random string until api is fetched for real data
    return "@"
  }, [])

  const avatarLetters = getAvatarLetter(name)

  const letterColors: Record<
    | "A"
    | "B"
    | "C"
    | "D"
    | "E"
    | "F"
    | "G"
    | "H"
    | "I"
    | "J"
    | "K"
    | "L"
    | "M"
    | "N"
    | "O"
    | "P"
    | "Q"
    | "R"
    | "S"
    | "T"
    | "U"
    | "V"
    | "W"
    | "X"
    | "Y"
    | "Z",
    string
  > = {
    A: "#FF5733",
    B: "#33FF57",
    C: "#3357FF",
    D: "#FF33A1",
    E: "#FF8F33",
    F: "#33FFF6",
    G: "#9D33FF",
    H: "#33FFCE",
    I: "#FF3333",
    J: "#33FF9E",
    K: "#6A33FF",
    L: "#FF3366",
    M: "#FFCF33",
    N: "#33A3FF",
    O: "#33FF5A",
    P: "#FF5733",
    Q: "#33FF57",
    R: "#3357FF",
    S: "#FF33A1",
    T: "#FF8F33",
    U: "#33FFF6",
    V: "#9D33FF",
    W: "#33FFCE",
    X: "#FF3333",
    Y: "#33FF9E",
    Z: "#6A33FF",
  }

  const getColorForInitials = useCallback(
    (letters: string) => {
      const firstLetter = letters[0].toUpperCase() as keyof typeof letterColors // Narrow the type
      return letterColors[firstLetter] || "#999"
    },
    [letterColors]
  )

  // Memoized color based on initials
  const avatarBgColor = useMemo(
    () => getColorForInitials(avatarLetters),
    [avatarLetters, getColorForInitials]
  )

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Avatar
        sx={{
          bgcolor: avatarBgColor,
          height: { xs: "40px", lg: "60px" },
          width: { xs: "40px", lg: "60px" },
        }}
      >
        {avatarLetters}
      </Avatar>

      <Typography
        sx={{
          fontSize: { xs: "10px", lg: "18px" },
          fontWeight: "500",
          marginLeft: "10px",
          textTransform: "capitalize",
        }}
        className="text-black"
      >
        {name}
      </Typography>
    </div>
  )
}
